import { render, staticRenderFns } from "./BoxPadding.vue?vue&type=template&id=38d2df5c&"
import script from "./BoxPadding.vue?vue&type=script&lang=js&"
export * from "./BoxPadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports